module.exports = __webpack_public_path__ + "static/media/plane@2x.4973aa2d.png";